<template>
  <div ref="intention">
    <el-popover
      placement="right"
      width="400"
      trigger="click"
      :value="popoverShow"
    >
      <div
        class="intention"
        slot="reference"
        :style="{ background: background }"
      >
        <el-badge :value="total" class="item">
          <div class="intention-img" @click="popoverShow = !popoverShow">
            <img src="@/assets/images/tools/intention.png" alt="" />
          </div>
        </el-badge>
        <!-- <div class="intention-span">意向地块</div> -->
      </div>

      <div class="intention-list">
        <div
          v-for="(item, index) in list"
          :key="index"
          class="intention-list-li"
          v-show="list.length"
        >
          <div class="intention-list-li-img">
            <img
              :src="
                item.pronounceImages && item.pronounceImages.length
                  ? imgUrl + item.pronounceImages[0].filePath
                  : '../../assets/images/home/land.png'
              "
              alt=""
            />
          </div>
          <div class="intention-list-li-r">
            <div class="intention-list-li-r-l" @click="goDeatil(item)">
              <div class="intention-list-li-r-l-span1">
                {{ item.parcelName || item.parcelCode }}
              </div>
              <div class="intention-list-li-r-l-c">
                <div>{{ item.typeName }}&nbsp;&nbsp; {{ item.countyName }}</div>
                <div style="color: red">
                  <span style="font-weight: bold">{{ item.area }}</span
                  >亩
                </div>
              </div>
              <div
                class="intention-list-li-r-l-span2"
                v-if="!item.supplyPeriod && item.supplyPeriod != 2"
                :style="{
                  color:
                    item.supplyPeriod == 1
                      ? '#18a7e9'
                      : item.supplyPeriod == 3
                      ? '#f6b73a'
                      : item.supplyPeriod == 4
                      ? '#00baaf'
                      : '',
                }"
              >
                {{
                  item.supplyPeriod == 1
                    ? "立等可供"
                    : item.supplyPeriod == 3
                    ? "计划可供"
                    : item.supplyPeriod == 4
                    ? "规划可用"
                    : ""
                }}
              </div>
            </div>
            <div
              class="intention-list-li-r-r"
              @click="handleDelete(item.parcelId)"
            >
              <i class="el-icon-delete"></i>
            </div>
          </div>
        </div>
        <div style="text-align: center" v-show="!list.length">暂无收藏</div>
      </div>
    </el-popover>
  </div>
</template>
<script>
import { infoFavoriteList, cancelFavoriteList } from "@/api/setting/investment";
export default {
  name: "intention",
  props: {
    background: {
      type: String,
      default: "#fff0",
    },
  },
  data() {
    return {
      imgUrl: systemConfig.imgServer + systemConfig.imgApi,
      list: [],
      searchForm: {
        current: 1,
        size: 10,
      },
      total: 0,
      refreshs: 0,
      isRefresh: 0,
      popoverShow: false,
    };
  },
  watch: {
    isRefresh: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.popoverShow = !this.popoverShow;
        this.getList();
      }
    },
  },
  mounted() {
    //监听注册事件
    this.$eventBus.on("isRefresh", (val) => {
      this.isRefresh = val;
    });
    this.getList();
    this.isRefresh = this.isRefresh;
  },
  methods: {
    getList() {
      infoFavoriteList(this.searchForm).then((res) => {
        if (res.data.success) {
          this.list = res.data.data.records;
          console.log(this.list);
          this.total = res.data.data.total;
        }
      });
    },
    handleDelete(id) {
      cancelFavoriteList(id).then((res) => {
        if (res.data.success) {
          this.getList();
          this.$message.success(res.data.msg);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    goDeatil(item) {
      //同页面跳转刷新不了
      this.$router.push({
        path: "/black",
        query: { path: "/land/detail", id: item.parcelId },
      });
    },
  },
};
</script>
<style scoped>
.intention {
  display: flex;
  align-items: center;
  padding: 11px 10px;
  cursor: pointer;
  color: #fba849;
  /* border: 2px solid #fba849; */
}
.intention-img {
  width: 20px;
  height: 20px;
}
.intention-img > img {
  width: 100%;
  height: 100%;
}
.intention-span {
  margin-left: 15px;
  font-size: 16px;
}
.intention-list {
  padding: 10px;
}
.intention-list-li {
  margin: 8px 0;
  display: flex;
}
.intention-list-li-img {
  width: 80px;
  height: 65px;
  overflow: hidden;
  border-radius: 4px;
}
.intention-list-li-img > img {
  width: 100%;
  height: 100%;
}
.intention-list-li-r {
  margin-left: 5px;
  width: calc(100% - 85px);
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.intention-list-li-r-l {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: calc(100% - 60px);
  margin-left: 10px;
  cursor: pointer;
}
.intention-list-li-r-l-c {
  display: flex;
  justify-content: space-between;
  margin: 5px 0;
  font-size: 13px;
  color: rgb(38, 38, 38);
}
.intention-list-li-r-l-span1 {
  font-size: 15px;
  font-weight: bold;
  color: #000;
}
.intention-list-li-r-l-span2 {
  font-size: 12px;
  font-weight: 600;
}
.intention-list-li-r-r {
  cursor: pointer;
}
</style>